import { Observable } from 'rxjs';

export abstract class QuestionnaireBannerRepository {
  abstract getQuestionnaireElgibility(questionnaireName: string): Observable<{ enabled: boolean }>;
  abstract declineQuestionnaire(questionnaireName: string): Observable<void>;
}
